<template>
  <div class="agreement flex flex-column h100-full bg-white">
    <div class="flex-auto">
      <iframe :src="contractUrl" frameborder="0" class="w100-full h100-full"></iframe>
    </div>
    <div class="footer-bar flex-shrink">
      <div v-if="hasCaAgreement" class="flex justify-center items-center agreement-check">
        <van-checkbox
          :value="agreementChecked"
          icon-size="15px"
          class="f12"
          @click.native.prevent="openCaAgreement"
        >
          我已阅读并同意<span class="blue">《{{ caAgreementName }}》</span>
        </van-checkbox>
      </div>
      <div class="text-center pad20-tb">
        <van-button round type="success" class="mar20-r" @click="toBack">返回</van-button>
        <van-button round type="danger" class="sign-submit-btn" :disabled="isSign" @click="sign">我已阅读并同意签署</van-button>
        <!-- <span class="sign-btn" @click="sign">签署协议</span> -->
      </div>
    </div>

    <van-popup
      v-model:show="authFilePopupShow"
      position="bottom"
      round
      :safe-area-inset-bottom="true"
      :close-on-click-overlay="false"
    >
      <div class="auth-file-popup pad20-tb pad30-lr">
        <div class="auth-file-popup__title fb f16">重要事项提醒</div>
        <div class="auth-file-popup__content f14 mar20-t gray3">
          <p class="mar10-b">1、请打印《企业授权书》并盖章，提供PDF或图片</p>
          <p>2、请保证授权书中<span class="red">被授权人与当前操作人保持一致</span>以免认证失败</p>
          <div class="auth-file-popup__link" @click="downloadAuthTemplate">点击下载《企业授权书》模版</div>
        </div>
        <div class="auth-file-popup__footer mar20-t text-center">
          <van-button round type="danger" @click="confirmAuthFileNavigate">已准备好</van-button>
          <div class="auth-file-popup__cancel blue text-center mar15-t" @click="authFilePopupShow = false">取消</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="scss" scoped>
  @import "./index.scss";
</style>

<script>
  import { Dialog, Toast } from "vant";
  import requestApi from "@/utils/requestApi";

  export default {
    data() {
      return {
        contractData: {},
        contInfo: {},
        orderId: "",
        time: 5,
        msg: "",
        isSign: false,
        agreementChecked: false,
        hasCaAgreement: false,
        caAgreementUrl: "",
        caAgreementName: "上上签CA电子认证协议",
        returnUrl: "",
        contractUrl: "",
        isAuthFile: false,
        authFileTemplateUrl: "https://nfs.nxin.com/cxt/CA_Authorization2606.docx",
        authFilePopupShow: false,
        pendingNavigateUrl: ""
      };
    },
    created() {
      if (/(nxin.com)$/.test(window.location.host)) {
        document.domain = "nxin.com";
      }
      if (/(dbn.cn)$/.test(window.location.host)) {
        document.domain = "dbn.cn";
      }

      this.orderId = this.$route.query.orderId;
      this.returnUrl = this.$route.query.retUrl ? decodeURIComponent(this.$route.query.retUrl) : "";
      this.contractUrl = this.$route.query.contractUrl;
      if (this.$route.query.caAgreementUrl) {
        this.caAgreementUrl = decodeURIComponent(this.$route.query.caAgreementUrl);
      }
      if (this.orderId && this.orderId !== "undefined") {
        requestApi.post("sctrading/contract/getBasicCa", {
          returnUrl: window.location.href,
          orderId: this.orderId,
          contractType: "receive"
        }).then(res => {
          const { code, data } = res;
          if (code == 0) {
            const { url, name, isAuthFile, templateUrl, authFileUrl, isExpired } = data || {};
            if (isExpired === false && url) {
              window.location.href = url;
              return;
            }
            if (url) {
              this.caAgreementUrl = url;
              this.caAgreementName = name || "上上签CA电子认证协议";
              this.hasCaAgreement = true;
            }
            this.isAuthFile = !!isAuthFile;
            this.authFileTemplateUrl = templateUrl || authFileUrl || this.authFileTemplateUrl;
          }
        });
      }
      if (this.orderId === "" || this.orderId === "undefined") {
        return;
      }
      this.$store
        .dispatch("order/signature/querySignElectronicReceipt", {
          orderId: this.orderId
        })
        .then(data => {
          this.contractData = data.contractData;
          this.contInfo = JSON.parse(data.contractData.contInfo);
          if (data.contractData && data.contractData.caAgreementUrl) {
            this.caAgreementUrl = data.contractData.caAgreementUrl;
          }
        });
    },
    methods: {
      goToCaUrl(url) {
        if (!url) {
          Toast("协议链接获取中，请稍后重试");
          return;
        }
        if (this.isAuthFile) {
          this.pendingNavigateUrl = url;
          this.authFilePopupShow = true;
          return;
        }
        window.location.href = url;
      },
      confirmAuthFileNavigate() {
        this.authFilePopupShow = false;
        if (this.pendingNavigateUrl) {
          window.location.href = this.pendingNavigateUrl;
        }
      },
      downloadAuthTemplate() {
        if (this.authFileTemplateUrl) {
          window.location.href = this.authFileTemplateUrl;
          return;
        }
        Toast("模版下载链接获取中，请稍后重试");
      },
      openCaAgreement() {
        if (this.caAgreementUrl) {
          this.agreementChecked = true;
          this.goToCaUrl(this.caAgreementUrl);
          return;
        }
        Toast("协议链接获取中，请稍后重试");
      },
      sign() {
        if (this.hasCaAgreement) {
          this.agreementChecked = true;
          this.goToCaUrl(this.caAgreementUrl);
          return;
        }
        Dialog.confirm({
          title: "确认签署并收货",
          message: "点击“确定”，即视为您(收货人)按照买家实际下单的具体信息(包括但不限于货品的品类、数量、质量标准、自提车辆信息等)完成收货，请勿将货品转让给其他人，且不得进行套现等不正当的行为。请您务必确保操作准确无误!否则，由此产生的风险和责任将由您自行承担。"
        }).then(() => {
          Toast.loading({
            mask: true,
            message: "合同正在签署中",
            duration: 0,
            overlay: true
          });
          this.$store.dispatch("order/signature/toSignElectronicReceipt", {
            orderId: this.orderId
          }).then((res) => {
            const { code, msg } = res;
            setTimeout(() => {
              if (code === "0") {
                this.toBack();
              } else {
                Toast(msg);
              }
            }, 5000);
          }).finally(() => {
            setTimeout(() => {
              Toast.clear();
            }, 6000);
          });
        });
      },
      toBack() {
        // eslint-disable-next-line no-undef
        window.location.href = this.returnUrl;
      }
    }
  };
</script>